import { render, staticRenderFns } from "./InputChannel.vue?vue&type=template&id=f8dfad40&scoped=true&"
import script from "./InputChannel.vue?vue&type=script&lang=js&"
export * from "./InputChannel.vue?vue&type=script&lang=js&"
import style0 from "./InputChannel.vue?vue&type=style&index=0&id=f8dfad40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8dfad40",
  null
  
)

export default component.exports